import React, { useEffect, useLayoutEffect, useState } from 'react';
import { BrowserRouter as Router, useHistory } from 'react-router-dom';
import { useQuery, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ConfigProvider } from 'antd';
import { ThemeProvider } from 'styled-components';
import moment from 'moment';
import 'moment/locale/ru';
import localeRU from 'antd/lib/locale-provider/ru_RU';
import {
 FeedbackIcon,
 ProfileIcon,
 LocationNavIcon,
 Frame,
 Broadcast,
 PaymentIcon,
} from './_assests';
import NotAvailable from './Shared/NotAvailable';
import queryClient from '../queryClient';
import srv from '../services';
import {
 Home,
 Feedback,
 Profile,
 SettingsData,
 OfficeMap,
 BroadCast,
 Payment,
} from '.';
import { Layout, Styles, theme } from './_common';
import 'antd/dist/antd.css';
import 'slick-carousel/slick/slick.css';
import DialogBanner from './dialogs/DialogBanner';
import DialogRegister from './dialogs/DialogRegister';
import DialogMeteringDeviceAdditional from './dialogs/DialogMeteringDeviceAdditional';
import DialogRestrictionsNotifications from './dialogs/DialogRestrictionsNotifications';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import './App.css';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import { HttpTransportType } from '@microsoft/signalr';
import { openDialogSbp } from '../store/reducers/openDialogSbpSlice';
import { config } from '../store/reducers/configSlice';
import ConfigObject from '../store/models/ConfigObject';
import { log } from 'console';
import Snackbar from '@mui/material/Snackbar';
import AccountBalance from '@mui/icons-material/AccountBalance';
import { appealAttachedFiles } from '../store/reducers/appealAttachedFilesSlice';
import { openChatWoot } from '../store/reducers/openChatWootSlice';

export default function App() {
 //  const leftNavigationTab = useSelector(
 //   (state: RootState) => state.leftNavigationTab,
 //   shallowEqual,
 //  );

 //  useEffect(() => {
 //   dispatch(setLeftNavigationCurrentTab(10));
 //  }, []);

 return (
  <QueryClientProvider client={queryClient}>
   <ConfigProvider locale={localeRU}>
    <ThemeProvider theme={theme}>
     <Router>
      <Styles />
      <Main />
     </Router>
    </ThemeProvider>
   </ConfigProvider>

   <ReactQueryDevtools
    position="bottom-right"
    toggleButtonProps={{ style: { filter: 'opacity(0.01)' } }}
   />
  </QueryClientProvider>
 );
}

interface notificationObject {
 id: number;
 notificationId: string;
 noticeOfRestriction: string;
 contractId: string;
}

function Main() {
 const history = useHistory();
 const dispatch = useDispatch<AppDispatch>();

 const { data: user, ...userQ } = useQuery('user', srv.getCurrentUser, {
  refetchOnWindowFocus: false,
  retry: 0,
 });

 const [showVostokBanner, setShowVostokBanner] = useState(false);
 const [firstTime, setFirstTime] = useState(true);
 const [isAisAvailable, setIsAisAvailable] = useState<boolean>(true);

 const [connection, setConnection] = useState(null);
 const [restrictionNotificationData, setRestrictionNotificationData] = useState(
  [],
 );
 const [isSuccess, setIsSuccess] = useState(true);

 const [snackBarOpen, setSnackBarOpen] = useState(false);
 const [snackBarMessage, setSnackBarMessage] = useState('');
 const [snackBarType, setSnackBarType] = useState('error');

 sessionStorage.removeItem('isProcess');
 sessionStorage.removeItem('isSecondProcess');

 useEffect(() => {
  const p = process.env?.REACT_APP_SITE_URL;

  const configObject: ConfigObject = {
   siteUrl: process.env?.REACT_APP_SITE_URL,
   siteUrlVostok: process.env?.REACT_APP_BASE_URL_VOSTOK,
   logoFileName: process.env?.REACT_APP_LOGO_FILE_NAME,
   companyShortName: process.env?.REACT_APP_LOGO_COMPANY_SHORT_NAME,
   companyLongName: process.env?.REACT_APP_LOGO_COMPANY_LONG_NAME,
   companyAddress: process.env?.REACT_APP_LOGO_COMPANY_ADDRESS,
   companyPhone: process.env?.REACT_APP_LOGO_COMPANY_PHONE_NUMBER,
   showChatWoot: process.env?.REACT_APP_SHOW_CHAT_WOOT,
   chatWootUrl: process.env?.REACT_APP_CHAT_WOOT_URL,
   chatWootSource: process.env?.REACT_APP_CHAT_WOOT_SOURCE,
   maxUrl: process.env?.REACT_APP_CHAT_MAX_URL,
   showVostokBanner: process.env?.REACT_APP_SHOW_VOSTOK_BANNER,
   privacyPolicy: process.env?.REACT_APP_PRIVACY_POLICY,
   agreementWitPermissions: process.env?.REACT_APP_AGREEMENT_WITH_PERMISSIONS,
   agreementWithoutPermissions:
    process.env?.REACT_APP_AGREEMENT_WITHOUT_PERMISSIONS,
   sliderPrefix: process.env?.REACT_APP_SLIDER_PREFIX,
   showPrivacyPolicy: process.env?.REACT_APP_SHOW_PRIVACY_POLICY,
   showAgreement: process.env?.REACT_APP_SHOW_AGREEMENT,
   signalRUrl: process.env?.REACT_APP_SIGNALR_URL,
   selectedLocation: process.env?.REACT_APP_SELECTED_LOCATION,
   logoMainHeight: process.env?.REACT_APP_LOGO_MAIN_HEIGHT,
   logoMenuHeight: process.env?.REACT_APP_LOGO_MENU_HEIGHT,
   showMain: process.env?.REACT_APP_SHOW_MAIN,
   showPayment: process.env?.REACT_APP_SHOW_PAYMENT,
   showSupport: process.env?.REACT_APP_SHOW_SUPPORT,
   showDevice: process.env?.REACT_APP_SHOW_DEVICE,
   showMap: process.env?.REACT_APP_SHOW_MAP,
   showSettings: process.env?.REACT_APP_SHOW_SETTINGS,
   vkUrl: process.env?.REACT_APP_VK_URL,
   userManual: process.env?.REACT_APP_USER_MANUAL,
   showDititalRubblePayment: process.env?.REACT_APP_SHOW_DIGITAL_RUBBLE_PAYMENT,
  };

  dispatch(config(configObject));
  dispatch(appealAttachedFiles(0));
 }, []);

 useEffect(() => {
  const newConnection = new HubConnectionBuilder()
   .withUrl(process.env?.REACT_APP_SIGNALR_URL, {
    transport: HttpTransportType.ServerSentEvents,
   })
   .withAutomaticReconnect()
   .configureLogging(LogLevel.Information)
   .build();

  setConnection(newConnection);
 }, []);

 useEffect(() => {
  try {
   if (connection && connection?._connectionState === 'Disconnected') {
    connection.start().then(() => {
     console.log('Подключен к хабу');

     connection.on('receiveaisstatus', (status: any) => {
      console.log('Проверка состояния АИС');

      srv.getAisAvailable().then((response: any) => {
       const aisAvailableData = response;
       const isAvalilable =
        aisAvailableData && aisAvailableData.isAvailable
         ? aisAvailableData.isAvailable
         : false;

       const isAvalilableMessage =
        aisAvailableData && aisAvailableData.message
         ? aisAvailableData.message
         : '';
       setIsAisAvailable(isAvalilable);
       localStorage.setItem('isAisAvailableMessage', isAvalilableMessage);
       history.push('/');
      });
     });

     connection.on('receivebankcallback', (payload: any) => {
      if (payload) {
       /**
        * сделать метод здесь обработка СБП после получения уведомления из банка.
        */
       try {
        const paymentData = localStorage.getItem('paymentData');

        if (paymentData) {
         const parsedData = JSON.parse(paymentData);

         if (payload?.mdOrder === parsedData?.orderId) {
          setSnackBarMessage('Оплата успешно завершена.');
          setSnackBarType('success');
          setSnackBarOpen(true);
          setIsSuccess(true);

          dispatch(openDialogSbp(false));
          localStorage.removeItem('paymentData');
         }
        }
       } catch {
        setSnackBarMessage('Оплата не завершена.');
        setSnackBarType('error');
        setSnackBarOpen(true);
        setIsSuccess(false);

        dispatch(openDialogSbp(false));
        localStorage.removeItem('paymentData');
       }
      }
     });
    });
    return () => {
     connection.off('receiveaisstatus');
     connection.off('receivebankcallback');
     connection.stop();
    };
   }
  } catch (err) {
   console.error('Ошибка подключения к хабу:', err);
  }
 }, [connection]);

 useEffect(() => {
  srv.getAisAvailable().then((response: any) => {
   const aisAvailableData = response;
   const isAvalilable =
    aisAvailableData && aisAvailableData.isAvailable
     ? aisAvailableData.isAvailable
     : false;

   const isAvalilableMessage =
    aisAvailableData && aisAvailableData.message
     ? aisAvailableData.message
     : '';
   setIsAisAvailable(isAvalilable);
   localStorage.setItem('isAisAvailableMessage', isAvalilableMessage);
   history.push('/');
  });

  dispatch(openChatWoot(null));
 }, []);

 useEffect(() => {
  if (user && firstTime) {
   srv.getShowVostokBanner().then((response) => {
    if (response && response.data) {
     const value = Boolean(Number(response.data));

     setFirstTime(false);
     setShowVostokBanner(value);
    }
   });
  } else {
   setShowVostokBanner(false);
  }
 }, [user]);

 const { data: contragent, ...contragentQ } = useQuery(
  'contragent',
  srv.getContragent,
  { enabled: !!user?.uid },
 );

 useEffect(() => {
  if (contragent && contragent?.uid) {
   srv.getRestrictionNotifications(contragent?.uid).then((response: any) => {
    if (
     response &&
     response?.data &&
     response?.data?.contracts &&
     response?.data?.contracts.length > 0
    ) {
     let readyArray: notificationObject[] = [];

     let index = 1;

     response?.data?.contracts.map((contractRedcord: any) => {
      if (
       contractRedcord &&
       contractRedcord?.notification &&
       contractRedcord?.notification.length > 0
      ) {
       contractRedcord?.notification.map((notificationRecord: any) => {
        const object: notificationObject = {
         notificationId: notificationRecord?.id,
         contractId: contractRedcord?.contractId,
         id: index,
         noticeOfRestriction: notificationRecord?.noticeOfRestriction,
        };

        readyArray.push(object);
        index++;
       });
      }
     });

     setRestrictionNotificationData(readyArray);
    }
   });
  }
 }, [contragent]);

 const contractsQ = useQuery(
  'contracts',
  () => srv.getContracts(contragent?.id),
  { initialData: [], enabled: !!contragent },
 );

 useQuery(
  'notifications',
  () => srv.getNotificationList({ ContragentId: contragent?.id }),
  {
   initialData: [],
   enabled: !!contragent?.id,
  },
 );

 useQuery(
  'notificationNotReadCount',
  () => srv.getNotificationNotReadCount({ ContragentId: contragent?.id }),
  {
   initialData: [],
   enabled: !!contragent?.id,
  },
 );

 useQuery('contragentList', srv.getContragentList, {
  initialData: [],
  enabled: !!user,
 });

 const { data: feature } = useQuery<Models.Feature>('feature', srv.getFeature, {
  initialData: {},
  enabled: !!user,
 });
 useQuery('date', srv.getServerDate, { initialData: moment().toJSON() });
 useQuery('answerTypes', srv.getAnswerTypes, {
  initialData: [],
  enabled: !!user,
 });
 useQuery('services', srv.getServices, { initialData: [], enabled: !!user });
 useQuery('territories', srv.getTerritories, {
  initialData: [],
  enabled: !!user,
 });

 useQuery('documents', srv.getWorkDocTypes, {
  initialData: [],
  enabled: !!user,
 });

 useQuery('topics', srv.getTopics, { initialData: [], enabled: !!user });
 useQuery('topicsAis', srv.getTopicsAis, { initialData: [], enabled: !!user });

 if (!user) return <Home isLoading={userQ.isLoading} />;

 const handleSnackBarClose = () => {
  setSnackBarOpen(false);
 };

 return (
  <>
   <Layout
    isLoading={contragentQ.isLoading || contractsQ.isLoading}
    error={contragentQ.error || contractsQ.error}
    navigation={[
     {
      url: '/contracts',
      name: 'Главная',
      icon: (
       <div
        style={{
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         justifyItems: 'center',
         alignContent: 'center',
         alignItems: 'center',
         fontSize: '10px',
        }}
       >
        <div>
         <ProfileIcon />
        </div>
        <div>Главная</div>
       </div>
      ),
      component: isAisAvailable ? Profile : NotAvailable,
     },

     {
      url: '/payment',
      name: 'Оплата',
      icon: (
       <div
        style={{
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         justifyItems: 'center',
         alignContent: 'center',
         alignItems: 'center',
         fontSize: '10px',
        }}
       >
        <div>
         <PaymentIcon />
        </div>
        <div>Оплата</div>
       </div>
      ),

      component: isAisAvailable ? Payment : NotAvailable,
     },

     {
      url: '/feedback',
      name: 'Поддержка клиентов',
      icon: (
       <div
        style={{
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         justifyItems: 'center',
         alignContent: 'center',
         alignItems: 'center',
         textAlign: 'center',
         fontSize: '10px',
        }}
       >
        <div>
         <FeedbackIcon />
        </div>
        <div>Поддержка клиентов</div>
       </div>
      ),
      component: isAisAvailable ? Feedback : NotAvailable,
      featured: feature?.totalCount > 0,
     },
     {
      url: '/broadcast',
      name: 'Работа с приборами учета',
      icon: (
       <div
        style={{
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         justifyItems: 'center',
         alignContent: 'center',
         alignItems: 'center',
         textAlign: 'center',
         fontSize: '10px',
        }}
       >
        <div>
         <Broadcast />
        </div>
        <div>Работа с приборами учета</div>
       </div>
      ),

      component: isAisAvailable ? BroadCast : NotAvailable,
     },
     {
      url: '/map',
      name: 'Офисы обслуживания',
      icon: (
       <div
        style={{
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         justifyItems: 'center',
         alignContent: 'center',
         alignItems: 'center',
         textAlign: 'center',
         fontSize: '10px',
        }}
       >
        <div>
         <LocationNavIcon />
        </div>
        <div>Офисы обслуживания</div>
       </div>
      ),

      component: OfficeMap,
     },
     {
      url: '/settings',
      name: 'Настройки',
      icon: (
       <div
        style={{
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center',
         justifyItems: 'center',
         alignContent: 'center',
         alignItems: 'center',
         textAlign: 'center',
         fontSize: '10px',
        }}
       >
        <div>
         <Frame />
        </div>
        <div>Настройки</div>
       </div>
      ),

      component: SettingsData,
     },
    ]}
   />

   {Number(process.env?.REACT_APP_SHOW_VOSTOK_BANNER) === 1 && (
    <DialogBanner showBanner={showVostokBanner} />
   )}

   <DialogRegister />
   <DialogMeteringDeviceAdditional />

   <Snackbar
    open={snackBarOpen}
    autoHideDuration={4000}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    message={
     <React.Fragment>
      <div
       style={{
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
       }}
      >
       <AccountBalance
        style={{
         color: isSuccess ? '#1890ff !important' : 'red !important',
         marginRight: '20px',
         width: '40px',
         height: '40px',
         opacity: 0.4,
        }}
       />
       <label>{snackBarMessage}</label>
      </div>
     </React.Fragment>
    }
    onClose={handleSnackBarClose}
    sx={{
     '& .MuiSnackbarContent-root': {
      borderRadius: '10px',
      backgroundColor: 'white !important',
      border: isSuccess
       ? '1px #1890ff solid !important'
       : '1px red solid !important',
      color: isSuccess ? '#1890ff !important' : 'red !important',
      fontWeight: 400,
      height: '80px !important',
      width: '400px !important',
      marginTop: '70%',
      fontSize: '20px',
     },
    }}
   ></Snackbar>

   {restrictionNotificationData &&
    restrictionNotificationData.length > 0 &&
    restrictionNotificationData.map((item: any, index: number) => {
     return <DialogRestrictionsNotifications item={item} user={user} />;
    })}
  </>
 );
}
